<template>
  <div>
    <h2 class="page-titles">REDEMPTION PAGE</h2>
    <div class="">
      <GroupOrderHeaderBanner
        :title="currentStepTitle"
        :headerText="currentStepHeaderText"
        :currentStep="creatingGroupOrderStep"
        @onPrevStep="validatePrevStep"
        @onNextStep="validateCurrentStep"
      />
      <transition name="slide-fade">
        <div class="trending-container" v-if="creatingGroupOrderStep === 1">
          <div class="">
            <div class="form-holder mb-0 flex flex-col md:flex-row">
              <div class="form-label">
                <p><strong>Page Name *</strong></p>
                <span>Required</span>
              </div>
              <div class="form-input form-input-value">
                <div class="form-input-value input-value">
                  <input
                    autocomplete="off"
                    placeholder="e.g. Holiday Swag or Employee Appreciation"
                    type="text"
                    class="form-control redemption-input"
                    v-model="groupOrderName"
                    @keyup.enter="createGroupOrder"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>

      <transition name="slide-fade">
        <div class="trending-container" v-if="creatingGroupOrderStep === 2">
          <div class="">
            <div class="form-holder mb-5 flex flex-col md:flex-row gap-4">
              <div class="form-label">
                <p><strong>Show prices</strong></p>
              </div>
              <div class="form-input form-input-value">
                <div
                  class="form-input-value input-value w-max flex gap-4 flex-wrap items-center"
                >
                  <label class="toggle-button">
                    <input
                      type="checkbox"
                      :checked="!showPrices"
                      v-model="showPrices"
                    />
                    <span class="toggle-slider round"></span>
                  </label>
                  <span class="text-xs"
                    >Display product prices on redemption page.</span
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="margin-top-2">
            <div class="form-holder flex flex-col md:flex-row gap-4">
              <div class="form-label">
                <p><strong>Auto-finalize </strong></p>
              </div>
              <div class="form-input form-input-value">
                <div
                  class="form-input-value input-value w-max flex flex-wrap xl:flex-nowrap gap-4 items-center"
                >
                  <label
                    class="toggle-button"
                    :class="{
                      'toggle-button--disabled': orderAutoFinalizing
                    }"
                  >
                    <input
                      :aria-checked="instantFinalizeState"
                      type="checkbox"
                      :checked="instantFinalizeState"
                      v-model="instantFinalizeState"
                      :disabled="orderAutoFinalizing"
                      @click.prevent="handleInstantFinalize($event)"
                    />
                    <span class="toggle-slider round"></span>
                  </label>
                  <span class="text-xs"
                    >Orders are created instantly as submissions are received.
                    No further action on orders can be taken if enabled.</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { layouts } from '../../helpers'
import GroupOrderHeaderBanner from './GroupOrderHeaderBanner'
import i18n from '../../internatinalization/i18n'

export default {
  name: 'GroupOrderCreate',

  components: { GroupOrderHeaderBanner },

  watch: {
    async creatingGroupOrderStep() {
      if (this.groupOrderDetails.id) {
        await this.$store.dispatch(
          'groupOrder/getGroupOrder',
          this.groupOrderDetails.id
        )
        this.groupOrderName = this.groupOrderDetails.name
        this.showPrices = this.groupOrderDetails.showPrices
      }
    }
  },

  data() {
    return {
      groupOrderName: '',
      showPrices: true,
      instantFinalize: false,
      groupOrderTiers: ['GroupOrderGallery']
    }
  },

  async created() {
    this.setLayout()
    if (this.groupOrderDetails.id) {
      await this.$store.dispatch(
        'groupOrder/getGroupOrder',
        this.groupOrderDetails.id
      )
      this.groupOrderName = this.groupOrderDetails.name
      this.showPrices = this.groupOrderDetails.showPrices
    }
  },

  methods: {
    validatePrevStep() {
      this.$store.commit(
        'groupOrder/CREATING_GROUP_ORDER_STEP',
        this.creatingGroupOrderStep - 1
      )
    },
    async validateCurrentStep() {
      if (this.creatingGroupOrderStep === 1) {
        if (this.groupOrderDetails.id) {
          try {
            if (this.groupOrderName) {
              await this.$store.dispatch('groupOrder/updateGroupOrder', {
                name: this.groupOrderName
              })
              this.$store.commit('groupOrder/CREATING_GROUP_ORDER_STEP', 2)
            } else {
              this.$store.dispatch(
                'notification/pushNotification',
                {
                  type: 'error',
                  messages: [i18n.t('validations.blank-grouporder-name')]
                },
                { root: true }
              )
            }
          } catch (error) {
            return error
          }
        } else {
          try {
            this.createGroupOrder()
          } catch (error) {
            console.log(error)
          }
        }
      } else {
        try {
          await this.$store.dispatch('groupOrder/updateGroupOrder', {
            name: this.groupOrderName,
            showPrices: this.showPrices
          })
          this.$store.commit(
            'groupOrder/CREATING_GROUP_ORDER_STEP',
            this.creatingGroupOrderStep + 1
          )

          this.$router.push({
            name: 'GroupOrderItemsSelection',
            params: { id: this.groupOrderDetails.id }
          })
        } catch (error) {
          console.log(error)
        }
      }
    },
    createGroupOrder() {
      this.$store.dispatch('groupOrder/createGroupOrder', {
        name: this.groupOrderName,
        showPrices: this.showPrices,
        autoFinalize: this.instantFinalize,
        selectionType: 'EXACTLY'
      })
    },
    handleInstantFinalize(e) {
      if (e.target.checked) {
        this.$store.dispatch(
          'groupOrder/startInstantFinalize',
          this.groupOrderDetails.id
        )
      } else {
        this.$store.dispatch(
          'groupOrder/stopInstantFinalize',
          this.groupOrderDetails.id
        )
      }
    },
    setLayout() {
      this.$store.dispatch('layout/setPageLayout', layouts.PAIGE_DASHBOARD)
    }
  },

  computed: {
    ...mapState({
      creatingGroupOrder: state => state.groupOrder.creatingGroupOrder,
      creatingGroupOrderStep: state => state.groupOrder.creatingGroupOrderStep,
      groupOrderDetails: state => state.groupOrder.groupOrderDetails,
      currentGroupOrderDetails: state =>
        state.groupOrder.currentGroupOrderDetails
    }),
    currentStepHeaderText() {
      switch (this.creatingGroupOrderStep) {
        case 1:
          return 'Redemption page name'

        default:
          return 'General Settings'
      }
    },
    currentStepTitle() {
      switch (this.creatingGroupOrderStep) {
        case 1:
          return 'Create a new redemption page'

        default:
          return 'Set up initial configurations'
      }
    },
    instantFinalizeState() {
      switch (this.groupOrderDetails.state) {
        case 'pending':
          return false
        case 'locked':
          return false
        case 'finalized':
          return false
        case 'auto_finalising':
          return true
        case 'validating_recipients':
          return true
        case 'validating_subscription':
          return true
        case 'lock_finalisation':
          return false
        default:
          return false
      }
    },
    orderAutoFinalizing() {
      if (this.groupOrderDetails.state === 'lock_finalisation') {
        return false
      } else {
        return this.$store.getters['groupOrder/orderAutoFinalizing']
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/global.scss';

.disabled {
  opacity: 0.6;
  pointer-events: none;
}

form {
  width: 100%;
  margin: 0rem 0rem 4rem 0rem;
  max-width: 40rem;

  input {
    font-family: $inter;
    &::placeholder {
      color: #9b9b9b;
      font-size: 0.813rem;
    }
  }

  .toggle-price {
    display: flex;
    align-items: center;
    margin-bottom: 1rem;
    gap: 1rem;

    span {
      font-family: $inter;
      font-weight: 700;
      font-size: 0.938rem;
    }
  }

  .toggle-finalize {
    display: flex;
    align-items: center;
    gap: 1rem;

    span {
      font-family: $inter;
      font-weight: 700;
      font-size: 0.938rem;
    }
  }

  .button-gemnote {
    padding: 0 38px;
  }
}

.text-xs {
  color: #514d43;
}

.card-header {
  .editorial {
    font-size: 1.25rem;
  }

  p {
    font-size: 0.838rem;
  }
}

.trending-container {
  margin-top: 1.25rem;
  padding: 1.6rem 1.66rem;
  border: 1px solid $main-6;
  border-radius: 2px;
  margin-bottom: 2rem;
  border-radius: 12px;
}

.toggle-button {
  &.toggle-button--disabled {
    > * {
      cursor: not-allowed !important;
    }
  }
}

.form-holder {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  // gap: 0.5rem;

  &.textarea {
    align-items: flex-start;

    .form-label {
      width: 20%;
    }
  }

  .form-label {
    width: 12%;
    display: flex;
    flex-direction: column;
    text-align: left;

    p {
      font-size: 0.838rem;
    }

    span {
      font-size: 0.608rem;
      color: rgba(35, 34, 32, 0.5);
      font-weight: 400;
    }
  }

  .form-input {
    width: 100%;

    .upload-option-holder {
      &.muted {
        .option-text,
        .option-desc {
          color: #a09c95;
        }
      }

      .option-text {
        display: block;
        margin: 1rem 0;
        text-align: left;
        padding: 0px 5rem;
      }

      .upload-button-holder {
        display: flex;
        align-items: center;
        gap: 1rem;

        .option-desc {
          font-size: 0.773rem;
          font-weight: normal;
        }
      }
    }

    .input-value {
      width: 60%;
      &.w-max {
        width: 100%;
      }
    }

    &.textarea-input {
      width: 100%;

      .input-value {
        width: 80% !important;
      }
    }

    input {
      font-weight: 400 !important;
      height: max-content;
      &::placeholder {
        color: #9b9b9b;
        font-size: 0.813rem;
      }
    }

    .custom-date-input {
      gap: 0.3rem;
      width: 20%;

      input {
        font-weight: 400 !important;
        height: max-content;
      }

      .divider {
        font-weight: 400;
        color: #232220;
        font-size: 0.9rem;
      }
    }

    .file-details {
      align-items: flex-start;

      .file-name-holder {
        gap: 0.6rem;
        align-items: center;
        font-weight: 600;

        p {
          font-size: 0.838rem;
        }

        button {
          font-size: 0.838rem;
        }
      }

      .file-count {
        font-size: 0.708rem;
        color: #232220;
      }
    }
  }
}

.button-gemnote--small {
  width: auto !important;
  padding: 0 2rem;
  height: 2.8rem;
  display: flex;
  margin-left: auto;
  gap: 20px;

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    background: #a09c95;
    color: #f5f2ee;
    border: none;
  }
}
.inline-inputs {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  align-items: flex-end;
}

@media (max-width: 768px) {
  .form-holder {
    .form-label {
      width: 100%;
      display: flex;
      flex-direction: column;
      text-align: left;
    }

    .form-input {
      width: 100%;

      .input-value {
        width: 100%;
      }
    }
  }
}
</style>
